export const UNDERSCORE = '───';
